export default __webpack_public_path__ + "static/media/Avatar-11-noback.0b6caa3a.png";